/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Personal / Commercial License.
 * See LICENSE_PERSONAL / LICENSE_COMMERCIAL in the project root for license information on type of purchased license.
 */

import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserData } from '../../interfaces/common/users';
import { ProjectData } from '../../interfaces/common/project';
import { UsersService } from './services/users.service';
import { ProjectsService } from './services/projects.service';
import { HttpService } from './api/http.service';
import { HttpServiceProjects } from './api/http.service.project';
import { UsersApi } from './api/users.api';
import { ProjectsApi } from './api/projects.api';

const API = [ ProjectsApi, UsersApi, HttpService, HttpServiceProjects];

const SERVICES = [
  { provide: UserData, useClass: UsersService },
  { provide: ProjectData, useClass: ProjectsService },
];

@NgModule({
  imports: [CommonModule],
})
export class CommonBackendModule {
  static forRoot(): ModuleWithProviders {
    return <ModuleWithProviders>{
      ngModule: CommonBackendModule,
      providers: [
        ...API,
        ...SERVICES,
      ],
    };
  }
}
